import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import TranslateRecoveryBoundary from "@/components/TranslateRecoveryBoundary";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <TranslateRecoveryBoundary>
      <App />
    </TranslateRecoveryBoundary>
  </HelmetProvider>
);

